import ReactMarkdown from "react-markdown";

/** First-party Markdown (a connector's detail page). Raw HTML is never rendered; links leave in a new tab. */
export function Markdown({ children }: { children: string }) {
  return <ReactMarkdown components={{ a: ({ node: _node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" /> }}>{children}</ReactMarkdown>;
}
